module.exports = __webpack_public_path__ + "img/letter-answer.586a7e44.svg";